// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Tokens */
    --ds-05x: 2px;
    --ds-1x: 4px; /* --ds-xs */
    --ds-2x: 8px; /* --ds-s */
    --ds-3x: 12px; /* --ds-sm */
    --ds-4x: 16px; /* --ds-m */
    --ds-5x: 20px;
    --ds-6x: 24px; /* --ds-l */
    --ds-7x: 28px;
    --ds-8x: 32px; /* --ds-xl */
    --ds-9x: 36px;
    --ds-10x: 40px;
    --ds-12x: 48px; /* --ds-2xl */
    --ds-13x: 52px;
    --ds-14x: 56px;
    --ds-16x: 64px; /* --ds-3xl */
    --ds-18x: 72px;
    --ds-24x: 96px; /* --ds-4xl */
    --ds-27x: 108px;
    --ds-28x: 112px;
    --ds-29x: 116px;
    --ds-30x: 120px;
    --ds-32x: 128px;
    --ds-35x: 140px;
    --ds-36x: 144px;
    --ds-40x: 160px;
    --ds-41x: 164px;
    --ds-42x: 168px;
    --ds-43x: 172px;
    --ds-44x: 176px;
    --ds-48x: 192px;
    --ds-50x: 200px;
    --ds-56x: 224px;
    --ds-64x: 256px;
    --ds-70x: 280px;
    --ds-73x: 292px;
    --ds-75x: 300px;
    --ds-80x: 320px;
    --ds-90x: 360px;
    --ds-100x: 400px;
    --ds-137x: 548px;
    --ds-140x: 560px;
    --ds-160x: 640px;
    --ds-190x: 760px;
    --ds-320x: 1280px;
    /* Aliases */
    --ds-2xs: var(--ds-05x);
    --ds-xs: var(--ds-1x);
    --ds-s: var(--ds-2x);
    --ds-sm: var(--ds-3x);
    --ds-m: var(--ds-4x);
    --ds-l: var(--ds-6x);
    --ds-xl: var(--ds-8x);
    --ds-2xl: var(--ds-12x);
    --ds-3xl: var(--ds-16x);
    --ds-4xl: var(--ds-24x);
    /* Gaps */
    --ds-gap-2xs: var(--ds-2xs);
    --ds-gap-xs: var(--ds-xs);
    --ds-gap-s: var(--ds-s);
    --ds-gap-sm: var(--ds-sm);
    --ds-gap-m: var(--ds-m);
    --ds-gap-l: var(--ds-l);
    --ds-gap-xl: var(--ds-xl);
    --ds-gap-negative-s: -8px;
    /* Layout */
    /* VW sizes */
    --ds-vw-38: 38vw;
    /* VH sizes */
    --ds-vh-80: 80vh;
    /* Open Drawer width, set by the Drawer; 0px when no Drawer is present. */
    --ds-drawer-width: 0px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
